import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify, {
  iconfont: 'fa',
  theme: {
    primary: '#F2784B',
    secondary: '#FAF9F7',
  },
});
